// extracted by css-extract-rspack-plugin
export default {"spaceNone":"0px","spaceSmall":"12px","spaceMedium":"20px","size28":"28px","wrapper":"Breadcrumbs-module__wrapper___D4e43","separator":"Breadcrumbs-module__separator___zqv40"};